<!-- 弃用 -->
<template>
  <div>
    <el-container class="auth-container word-container">
      <el-aside class="auth-aside" width="200px">
        <el-input
          placeholder="输入分类名称搜索"
          v-model="filterText"
          clearable
          size="mini"
          class="search-type"
          ><i slot="suffix" class="el-input__icon el-icon-search"></i
        ></el-input>
        <el-tree
          style="height: 100%"
          :data="listData"
          @node-click="nodeClick"
          @check="handleCheckChange"
          node-key="departmentId"
          :default-expanded-keys="defaultShowNodes"
          :default-checked-keys="defaultCheckedKeys"
          :expand-on-click-node="false"
          :current-node-key="currentNodeKey"
          ref="authTree"
          :highlight-current="true"
          :check-on-click-node="true"
          :props="defaultProps"
          class="tree filter-tree"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span
              style="position: absolute; top: 5px; right: 10px; z-index: 9999"
            >
              <el-popover
                placement="right"
                width="60"
                trigger="click"
                :ref="'popover-' + node.id"
              >
                <ul class="popover-ul">
                  <li :style="clickTap == 1 ? 'background-color: #ECEFF4' : ''">
                    <span @click="addTree(node, data,'新增')">新建子分类</span>
                  </li>
                  <li
                    @click="() => addTree(node, data,'修改')"
                    :style="clickTap == 2 ? 'background-color: #ECEFF4' : ''"
                  >
                    修改分类
                  </li>
                  <li
                    @click="() => remove(node, data)"
                    :style="clickTap == 3 ? 'background-color: #ECEFF4' : ''"
                  >
                    删除分类
                  </li>
                </ul>
                <i
                  class="el-icon-s-tools"
                  slot="reference"
                  @click="closePopover('popover-' + node.id)"
                ></i>
              </el-popover>
            </span>
          </span>
        </el-tree>
      </el-aside>
      <el-main class="auth-main">
        <el-col
          :span="3"
          style="float: left; margin-bottom: 10px; margin-right: 10px"
        >
          <el-input
            size="mini"
            v-model="querySensitiveWord"
            placeholder="敏感词"
            @blur="blurWord"
            @clear="clearWord"
            clearable
          >
            <!-- <el-button slot="append" icon="el-icon-search"></el-button> -->
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-col>
        <el-col
          :span="3"
          style="float: right; margin-bottom: 10px; text-align: right"
        >
          <el-button type="primary" size="mini">添加敏感词</el-button>
        </el-col>
        <el-table
          size="medium"
          v-loading="loading"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          ref="singleTable"
          :height="tableHeight"
          :highlight-current-row="true"
          :data="tableData"
          element-loading-text="读取数据加载中"
          style="width: 100%"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="sensitiveWord"
            label="敏感词"
            min-width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="mobile"
            label="补充词语"
            min-width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="departmentName"
            label="不包含词语"
            min-width="280"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="departmentName"
            label="操作人"
            min-width="280"
            align="center"
          ></el-table-column>
          <el-table-column prop="userId" label="操作时间" min-width="150px">
          </el-table-column>
          <el-table-column fixed="right" prop="status" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEdit(scope.row)"
                >修改</el-button
              >
              <el-button type="text" size="small" @click="handleDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <Pagination
          v-bind:childMsg="pageparm"
          :pageSizes="pageSizes"
          @callBack="callBack"
        ></Pagination>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { getDepartmentList } from "../../api/staff/staff.js";
export default {
  data() {
    return {
      defaultShowNodes: [1], //树形默认展开节点编号
      defaultCheckedKeys: [1], //默认勾选的节点的 key 的数组
      currentNodeKey: "", //当前选中的节点
      tableHeight: 500, //表格距离浏览器底部距离，初始为200
      listData: [
        {
          departmentId: 0,
          departmentName: "敏感词",
          children: [
            { departmentId: 1, departmentName: "免费治疗", children: [] },
            { departmentId: 3, departmentName: "免费治疗2", children: [] },
          ],
        },
      ], //树tree--数据
      tableData: [{ sensitiveWord: 111 }, { sensitiveWord: 2222 }], //表格数据
      loading: false, //加载弹窗
      //配置树选项
      defaultProps: {
        id: "departmentId",
        children: "children",
        label: "departmentName",
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      // 当前组件分页参数
      formInline: {
        currentPage: 1,
        pageSize: 10,
      },
      pageSizes: [10, 15, 20, 25], //分页条数
      tempDepartmentId: 0, //树---选中的ID
      tempDepartmentIdMax: 0, //树---选中的部门
      tempDepartmentName: "", //树---选中的名称
      querySensitiveWord: "",
      //输入分类名称
      filterText: "",
      clickTap: "", //选中状态
      popoverVisible: false, //添加-树-修改分类
      popoverInput: "", //添加--树--输入框
    };
  },
  watch: {
    filterText(val) {
      this.$refs.authTree.filter(val);
    },
  },
  created() {
    console.log("666611");
    // this.getDepartmentListData(); //获取树节点
    this.getTableData(); //获取列表接口
  },
  methods: {
    btnClose(key, btn, data) {
      this.popoverVisible = false;
      if (btn === "取消") {
        // this.$refs["popover-add"].doClose();
        this.$refs[key].doClose();
        return;
      }
      if (this.popoverInput === "") {
        this.$message.warning("敏感词不能为空 !");
        return;
      }
      // this.$refs["popover-add"].doClose();
      this.$refs[key].doClose();
      if (this.clickTap == 1) {
        const newChild = {
          departmentId: data.departmentId * 10 + data.children.length,
          departmentName: this.popoverInput,
          children: [],
        };
        data.children.push(newChild);
        this.defaultShowNodes = [data.departmentId];
        this.$refs.authTree.setCurrentKey(data.departmentId);
      } else if (this.clickTap == 2) {
        data.departmentName = this.popoverInput;
      }
    },
    // 添加树的新建子分类
    addTree(node, data,btn) {
      this.popoverInput = "";
      let title = '新增'
      if(btn=='新增'){
        this.clickTap = 1;
        
      }else{
        this.clickTap = 2;
        title = '修改'
      }
      
      // this.$refs["popover-add"].doShow();
      this.$prompt("请输入敏感词", title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\u4e00-\u9fa5]{0,}$/, //匹配全中文
        inputErrorMessage: "请输入中文", //不符合正则匹配的提示语句
      })
        .then(({ value }) => {
          if(value==''){
            return
          }
          //可以在这里发请求，http是我模拟的一个虚假的封装好的axios请求,()可写请求参数
          this.$message({
            type: "success",
            message: title+"成功",
          });
          //请求成功需局部刷新该节点，调用方法,把节点信息node传入
          //  this.partialRefresh(node)
          const newChild = {
            departmentId: data.departmentId * 10 + data.children.length,
            departmentName: value,
            children: [],
          };
          data.children.push(newChild);
          this.defaultShowNodes = [data.departmentId];
          this.$refs.authTree.setCurrentKey(data.departmentId);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //实现局部刷新，在点击弹窗处调用的
    partialRefreshpartialRefresh(node) {
      //设置loaded为false；模拟一次节点展开事件，加载重命名后的新数据；
      node.loaded = false;
      node.expand();
      //新建子节点是刷新一次本节点的展开请求，而重命名和删除则需要刷新父级节点的的展开事件，
      //可以设置node.parent.loaded = false;node.parent.expand();
    },
    // 添加树节点
    edit(data) {
      this.clickTap = 2;
      // this.$refs["popover-add"].doShow();
      this.popoverInput = data.departmentName;
    },
    // 删除树节点
    remove(node, data) {
      this.clickTap = 3;
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.departmentId === data.departmentId);
      children.splice(index, 1);
    },
    // 关闭popover弹窗
    closePopover(popover) {
      // for (const key in this.$refs) {
      //   if (key.indexOf("popover") !== -1) {
      //     this.$refs[key].doClose();
      //   }
      // }
    },
    // 修改行
    handleEdit(row) {
      console.log("修改行", row);
    },
    // 删除行
    handleDel(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 分页子组件回调
    callBack(parm) {
      this.formInline.currentPage = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.loading = true;
    },
    // 清除-搜索敏感词触发
    clearWord() {
      this.loading = true;
      this.formInline.currentPage = 1;
      // this.$refs.authTree.setCurrentKey(this.tempDepartmentIdMax); //展开树
      this.tempDepartmentId = this.tempDepartmentIdMax;
    },
    // 输入搜索-敏感词触发
    blurWord() {
      this.formInline.currentPage = 1;
      // this.$refs.authTree.setCurrentKey(tempId); //展开树的ID

      // 调列表接口
    },
    //当复选框被点击的时候触发
    handleCheckChange: function (data, checked) {},
    //节点被点击时的回调
    nodeClick(data, node, s) {
      this.loading = true;
      this.tempDepartmentId = node.data.departmentId;
      this.tempDepartmentName = node.data.departmentName;
      this.formInline.currentPage = 1;
      // this.formInline.pageSize = 10
      this.querySensitiveWord = "";

      this.getTableData();
    },
    //获取树节点
    getDepartmentListData() {
      getDepartmentList(localStorage.getItem("Authorization")).then((res) => {
        console.log("获取列表");
        // this.listData = res.data.resultDepartSort;
        // this.$nextTick(() => {
        //   //等树结构渲染完成后设置节点高亮
        //   this.$refs.authTree.setCurrentKey(
        //     res.data.resultDepartSort[0].departmentId
        //   );
        // });
        // this.tempDepartmentId = res.data.resultDepartSort[0].departmentId;
        // this.tempDepartmentIdMax = res.data.resultDepartSort[0].departmentId;
        // this.tempDepartmentName = res.data.resultDepartSort[0].departmentName;
      });
    },
    // 获取列表数据
    getTableData() {
      // 请求接口
      setTimeout(() => {
        this.loading = false; //接口回来关闭加载
      }, 400);
    },
    //设置table距离浏览器底部的高度
    controlHeight() {
      this.$nextTick(function () {
        this.tableHeight =
          window.innerHeight - this.$refs.singleTable.$el.offsetTop - 215;

        // 监听窗口大小变化
        let self = this;
        window.onresize = function () {
          self.tableHeight =
            window.innerHeight - self.$refs.singleTable.$el.offsetTop - 205;
        };
      });
    },
  },
  mounted() {
    this.controlHeight();
  },
};
</script>
<style lang="scss" scoped>
.pop-add {
  display: flex;
  span {
    margin: 13px 5px 0 0;
    width: 70px;
  }
  .el-input {
    min-width: 90px;
  }
}
.search-type {
  width: 66%;
  margin: auto;
  display: block;
  margin-bottom: 20px;
}
.popover-ul {
  padding: 0px;
  margin: 0px;
  li {
    font-size: 12px;
    list-style-type: none;
    padding: 8px 10px;
    cursor: pointer;
    border-bottom: 1px dashed #b8b9bb;
    &:last-child {
      border-bottom: none;
    }
  }
}

.auth-container {
  height: 100%;
  width: 100%;
  display: flex;
  object-fit: fill;
  .el-input {
    min-width: 152px;
  }
}

.auth-aside {
  width: 280px !important;
  padding: 0px 10px;
  height: 100%;
  object-fit: fill;
  margin-left: 5px;
}

.auth-main {
  padding: 0px;
  height: 100%;
  margin-right: 15px;
}
/* 树形结构节点添加连线 */
.tree /deep/ .el-tree-node {
  position: relative;
  padding-left: 5px;
}

.tree /deep/ .el-tree-node__children {
  padding-left: 16px;
}

.tree /deep/ .el-tree-node :last-child:before {
  height: 38px;
}

.tree /deep/ .el-tree > .el-tree-node:before {
  border-left: none;
}

.tree-container /deep/ .el-tree > .el-tree-node:after {
  border-top: none;
}

.tree /deep/ .el-tree-node:before {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree /deep/ .el-tree-node:after {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}
.tree /deep/ .el-tree-node__expand-icon.is-leaf {
  display: none;
}

.tree /deep/ .el-tree-node:before {
  border-left: 1px dashed #b8b9bb;
  bottom: 0px;
  height: 100%;
  top: -26px;
  width: 1px;
}

.tree /deep/ .el-tree-node:after {
  border-top: 1px dashed #b8b9bb;
  height: 20px;
  top: 12px;
  width: 15px;
}
.tree /deep/ .el-tree-node__content {
  padding-left: 6px !important;
}
.tree /deep/ .el-tree-node__content > .el-tree-node__expand-icon {
  padding: 0px;
}
.tree /deep/ .el-tree-node.is-current > .el-tree-node__content {
  /* background-color: #409eff; */
  background-color: #f8910a;
  color: white;
}
</style>